import React from "react";
import { NavLink } from "react-router-dom";
import { usePendingCount } from "../hooks/usePendingCount.js";
import { useAuth } from "../context/AuthContext.jsx";
import { useNavBadgeCounts } from "../context/NavBadgeCountsContext.jsx";
import {
  badgeValue,
  buildBottomNavItems,
  NAV_BADGE_LABELS,
} from "../lib/navConfig.js";
import { CountBadge } from "./ui";

// PR-B: the "Gestión" tab now points at /admin. Both the bottom nav and the
// desktop TopNav use the full "Administración" label; the rendered <span>
// truncates and the `title` attribute below provides a hover tooltip for
// narrow viewports where the label is clipped.

export default function BottomNav() {
  // Ver el comentario de TopNav: alertas por contexto, pendientes por hook.
  const { alerts } = useNavBadgeCounts();
  const pendingCount = usePendingCount();
  const { user } = useAuth();
  const items = buildBottomNavItems(user?.role);

  // Los contadores en vivo de esta pantalla, indexados por la clave que el
  // destino declara en `badge` (lib/navConfig.js).
  const counts = { alerts, pending: pendingCount };

  if (items.length === 0) return null;

  return (
    // pb-[env(...)]: instalada como PWA no hay barra del navegador, así que en
    // iPhone los tabs quedarían justo bajo el home indicator.
    <nav className="fixed bottom-0 left-0 right-0 z-[300] md:hidden bg-background-elevated shadow-bar border-t border-border-muted pb-[env(safe-area-inset-bottom)]">
      <div className="flex">
        {items.map(({ path, label, icon, end, badge }) => {
          const count = badgeValue(badge, counts);
          return (
            <NavLink
              key={path}
              to={path}
              end={end}
              className={({ isActive }) =>
                // Inactivo en text-dim, no text-muted: la etiqueta es de 10px y
                // sobre background-dark el muted da 3.98:1 (AA pide 4.5:1).
                // text-dim llega a 7.38:1 y sigue leyéndose como secundario
                // frente al azul del activo.
                `flex-1 flex flex-col items-center py-2 gap-0.5 transition-colors ${
                  isActive ? "text-primary" : "text-text-dim"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div
                    className={`relative flex items-center justify-center w-10 h-7 rounded-lg transition-colors ${
                      isActive ? "bg-surface-1/60" : ""
                    }`}
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "20px" }}
                      aria-hidden="true"
                    >
                      {icon}
                    </span>
                    <CountBadge
                      count={count}
                      label={NAV_BADGE_LABELS[badge]}
                      className="absolute -top-0.5 -right-0.5 h-[14px] min-w-[14px] px-0.5"
                    />
                  </div>
                  <span
                    title={label}
                    className="text-2xs font-medium truncate max-w-full"
                  >
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
